import { graphql } from "relay-runtime"

export const deGeneralAttestationsFragment = graphql`
  fragment deGeneralAttestationsFragment on de_GeneralAttestation {
    id
    fileId
    progressNoteId
    name
    message
    subject
    signedBy
    signedAt
    updatedAt
    updatedBy
    createdAt
    createdBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
